const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    containerLineOne: {
        display: 'flex',
        flexDirection: 'row',
    },
    containerLineTwo: {
        display: 'block',
        flexDirection: 'row',
    },
    textField: {
        marginLeft: 0,
        marginRight: theme.spacing.unit,
        width: 248,
        [theme.breakpoints.up('xs')]: {
            width: '100%',
            margin: 0
        },
    },
    menu: {
        width: 200,
    },
    filterButton: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
    selectMenuItem: {
        fontSize: '14px',
        padding: '0 15px'
    },
    selectMenuItemSpan: {
        color: 'rgba(0, 0, 0, 0.54)'
    },
    multiSelectTitle: {
        color: 'rgba(0, 0, 0, 0.54)',
        margin: '15px 0 5px 0'
    },
    multiSelectNoTags: {
        margin: '15px 0 5px 0'
    },
    pageTypeSelects: {
        marginTop: 15
    },
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        height: '600px',
        width: '40%',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    dialogActionsBtn: {
        margin: '8px 19px'
    },
    cloneActionsBtns: {
        position: 'absolute',
        bottom: 0,
        left: 15,
    },
    cloneActionsBtn: {
        margin: '0px'
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/pages/style/styles.js